import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconHomeKey.module.css';

const IconHomeKey = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      viewBox="0 0 810 809.999993"
      width="64"
      height="64"
      xmlns="http://www.w3.org/2000/svg"
      zoomAndPan="magnify"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="d30a19350e">
          <path
            d="M 405 0 C 181.324219 0 0 181.324219 0 405 C 0 628.675781 181.324219 810 405 810 C 628.675781 810 810 628.675781 810 405 C 810 181.324219 628.675781 0 405 0 Z M 405 0 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="22f69988d5">
          <path
            d="M 82 143.398438 L 728 143.398438 L 728 633 L 82 633 Z M 82 143.398438 "
            clip-rule="nonzero"
          />
        </clipPath>
      </defs>
      <g clip-path="url(#d30a19350e)">
        <rect
          x="-81"
          width="972"
          fill="#727c80"
          y="-80.999999"
          height="971.999992"
          fill-opacity="1"
        />
      </g>
      <g clip-path="url(#22f69988d5)">
        <path
          fill="#ffffff"
          d="M 722.691406 570.753906 L 693.78125 557.589844 L 693.910156 513.445312 L 661.125 501.183594 L 657.640625 458.976562 L 635.957031 451.75 L 616.078125 419.480469 L 637.246094 406.1875 L 626.277344 388.246094 L 615.304688 390.183594 L 615.304688 390.054688 C 650.410156 351.976562 659.964844 298.800781 635.050781 258.269531 C 613.753906 223.808594 572.96875 207.546875 530.632812 212.320312 C 530.503906 212.0625 530.503906 211.804688 530.375 211.546875 C 513.464844 170.246094 473.710938 143.398438 429.054688 143.398438 C 368.90625 143.398438 319.859375 192.445312 319.859375 252.59375 C 319.859375 264.597656 321.792969 276.339844 325.539062 287.570312 L 124.574219 344.363281 L 160.972656 367.59375 L 82.238281 491.117188 L 304.886719 632.96875 L 383.621094 509.316406 L 421.4375 533.453125 L 392.527344 355.332031 C 398.335938 357.398438 404.140625 358.949219 410.207031 359.980469 L 411.5 360.238281 C 413.695312 370.175781 417.566406 379.855469 423.117188 388.890625 C 447.898438 429.164062 499.269531 444.523438 548.703125 430.710938 L 543.152344 439.359375 L 554.253906 457.300781 L 570.257812 447.492188 L 674.804688 617.089844 L 711.332031 619.15625 L 727.726562 591.277344 Z M 312.757812 530.097656 C 279.199219 551.394531 218.925781 543.90625 205.5 541.84375 C 203.824219 541.585938 202.273438 540.550781 201.5 539.003906 C 187.171875 512.285156 182.007812 481.179688 180.203125 465.042969 C 179.039062 454.589844 179.816406 444.007812 182.785156 434.066406 C 193.367188 398.316406 222.925781 391.601562 222.925781 391.601562 C 268.359375 379.984375 285.65625 432.261719 285.65625 432.261719 C 328.117188 437.292969 338.058594 465.433594 338.058594 465.433594 C 354.964844 504.539062 312.757812 530.097656 312.757812 530.097656 Z M 337.414062 342.683594 C 326.054688 335.457031 322.828125 320.484375 329.925781 309.125 C 330.957031 307.578125 332.121094 306.15625 333.410156 304.996094 C 334.445312 306.800781 335.347656 308.609375 336.378906 310.417969 C 341.285156 318.417969 356.644531 335.199219 364.128906 342.425781 C 356.257812 347.589844 345.800781 347.976562 337.414062 342.683594 Z M 358.839844 302.285156 C 358.0625 301.125 357.289062 299.832031 356.515625 298.671875 C 358.96875 299.316406 361.289062 300.21875 363.613281 301.640625 C 370.324219 305.898438 374.070312 312.867188 374.714844 320.226562 C 369.679688 314.933594 360.773438 304.996094 358.839844 302.285156 Z M 409.304688 336.230469 C 402.722656 334.683594 396.398438 332.359375 390.332031 329.390625 L 388.265625 328.359375 L 379.230469 272.46875 L 347.996094 281.246094 C 347.996094 281.117188 347.996094 281.117188 347.867188 280.988281 C 344.640625 271.824219 343.089844 262.273438 343.089844 252.59375 C 343.089844 205.222656 381.683594 166.628906 429.054688 166.628906 C 462.742188 166.628906 493.460938 186.507812 507.398438 217.226562 C 495.65625 220.710938 484.039062 225.746094 472.9375 232.714844 C 433.183594 257.109375 410.207031 297.25 409.304688 336.230469 Z M 485.84375 317 C 481.328125 302.285156 487.007812 285.894531 500.558594 277.503906 C 504.300781 275.179688 508.304688 273.761719 512.433594 272.984375 C 508.304688 290.152344 499.140625 305.382812 485.84375 317 Z M 536.828125 336.359375 C 525.082031 343.589844 510.628906 342.8125 499.785156 335.714844 C 517.597656 320.484375 530.246094 299.703125 535.410156 276.988281 C 540.441406 279.828125 544.832031 283.699219 548.058594 288.863281 C 558.125 305.125 553.089844 326.292969 536.828125 336.359375 Z M 706.429688 616.445312 C 704.492188 617.609375 702.039062 617.351562 701.007812 615.671875 L 579.421875 418.320312 C 578.390625 416.773438 579.164062 414.449219 581.230469 413.15625 C 583.164062 411.996094 585.617188 412.253906 586.652344 413.933594 L 708.234375 611.285156 C 709.269531 612.960938 708.496094 615.15625 706.429688 616.445312 Z M 706.429688 616.445312 "
          fill-opacity="1"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  );
};

const { string } = PropTypes;

IconHomeKey.defaultProps = {
  className: null,
  rootClassName: null,
};

IconHomeKey.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconHomeKey;
